import fs from "node:fs"
import path from "node:path"
import { argv, exit } from "node:process"

const getArgValue = (argName: string): string | null => {
  const args = argv
  const arg = args.find((arg) => arg.startsWith(`--${argName}=`))
  if (arg) {
    return arg.split("=")[1]
  }
  return null
}

const newChainIdString = getArgValue("chainId")
const templateDir = getArgValue("templateDir")
const outputDir = getArgValue("outputDir")

if (!newChainIdString) {
  console.error(
    "Error: --chainId argument is missing. Please provide it like --chainId=12345"
  )
  exit(1)
}

if (!templateDir) {
  console.error(
    "Error: --templateDir argument is missing. Please provide it like --templateDir=/path/to/templates"
  )
  exit(1)
}

if (!outputDir) {
  console.error(
    "Error: --outputDir argument is missing. Please provide it like --outputDir=/path/to/output"
  )
  exit(1)
}

const newChainIdNum = Number.parseInt(newChainIdString, 10)
if (Number.isNaN(newChainIdNum)) {
  console.error("Error: --chainId must be a number.")
  exit(1)
}

// At this point we know these are strings because we checked above
const sourceFilePath = path.join(templateDir, "84532.json")
const targetFilePath = path.join(outputDir, `${newChainIdString}.json`)

async function main() {
  try {
    // Ensure output directory exists - we know outputDir is a string at this point
    await fs.promises.mkdir(outputDir as string, { recursive: true })

    const sourceContent = await fs.promises.readFile(sourceFilePath, "utf-8")
    const chainConfig = JSON.parse(sourceContent)

    const originalRpcFromTemplate = chainConfig.rpc

    chainConfig.name = newChainIdString
    chainConfig.chainId = newChainIdString

    const placeholderRpc = "<YOUR RPC URL (debug_traceCall enabled)>"
    if (chainConfig.rpc === placeholderRpc) {
      chainConfig.rpc = `http://host.docker.internal:${newChainIdString}`
    }

    const newJsonContent = JSON.stringify(chainConfig, null, 4)

    await fs.promises.writeFile(targetFilePath, newJsonContent)

    console.log(
      `Successfully duplicated and updated chain config to ${targetFilePath}`
    )
    if (originalRpcFromTemplate !== chainConfig.rpc) {
      console.log(
        `RPC in new file: ${chainConfig.rpc} (changed from: ${originalRpcFromTemplate})`
      )
    } else {
      console.log(
        `RPC in new file: ${chainConfig.rpc} (unchanged from template)`
      )
    }
  } catch (error) {
    if (error instanceof Error) {
      console.error(`An error occurred: ${error.message}`)
    } else {
      console.error("An unknown error occurred.")
    }
    exit(1)
  }
}

main()
